var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11668_67852)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    stroke: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41033 3.1817C6.44701 3.10737 6.55299 3.10737 6.58967 3.1817L7.50536 5.03708C7.51992 5.06659 7.54808 5.08705 7.58065 5.09178L9.62818 5.3893C9.7102 5.40122 9.74295 5.50202 9.6836 5.55987L8.202 7.00408C8.17843 7.02706 8.16767 7.06016 8.17324 7.0926L8.523 9.13185C8.53701 9.21354 8.45126 9.27584 8.3779 9.23727L6.54653 8.27446C6.5174 8.25915 6.4826 8.25915 6.45347 8.27446L4.6221 9.23727C4.54874 9.27584 4.46299 9.21354 4.477 9.13185L4.82676 7.0926C4.83233 7.06016 4.82157 7.02706 4.798 7.00408L3.3164 5.55987C3.25705 5.50202 3.2898 5.40122 3.37182 5.3893L5.41935 5.09178C5.45192 5.08705 5.48008 5.06659 5.49464 5.03708L6.41033 3.1817Z",
    stroke: "#9747FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11668_67852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "matrix(-1 0 0 -1 13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature);
export default __webpack_public_path__ + "static/media/feature.aa63fea1cc9ea26f1bdfb92c8449b541.svg";
export { ForwardRef as ReactComponent };